// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.stock_type_enum_ee62bcf9 */
var StockTypeEnumEe62bcf9;
(function (StockTypeEnumEe62bcf9) {
    StockTypeEnumEe62bcf9["Mother Stock"] = "Mother Stock";
    StockTypeEnumEe62bcf9["Backup Stock"] = "Backup Stock";
    StockTypeEnumEe62bcf9["Working Stock"] = "Working Stock";
})(StockTypeEnumEe62bcf9 || (StockTypeEnumEe62bcf9 = {}));
;
export default StockTypeEnumEe62bcf9;
/** Zod schema for stock_type_enum_ee62bcf9 */
export const stockTypeEnumEe62bcf9 = z.nativeEnum(StockTypeEnumEe62bcf9);
//# sourceMappingURL=StockTypeEnumEe62bcf9.js.map